import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserRideMechanicGame from 'src/games/RideMechanicGame/Main';

interface RideMechanicGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class RideMechanicGame extends React.Component<RideMechanicGameProps> {
    constructor(props: RideMechanicGameProps) {
        super(props);
        bindAllOfThis(this, RideMechanicGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserRideMechanicGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default RideMechanicGame;



// WEBPACK FOOTER //
// ./src/pages/game/RideMechanicGame.tsx